module.exports = __webpack_public_path__ + "static/media/Trash.e90335de.svg";